const collator = new Intl.Collator('en', { numeric: true });
export function naturalSort<T extends string>(string1: T, string2: T) {
  return collator.compare(string1, string2);
}

export const naturalSortByProperty = <T>(arrayToSort: ReadonlyArray<T>, getPropertyFunction: (item: T) => string) =>
  arrayToSort.toSorted((a, b) => naturalSort(getPropertyFunction(a), getPropertyFunction(b)));
